import type { AlertProps } from 'antd';
import { Alert } from 'antd';
import React from 'react';

/** `showIcon` is not part of `AlertConfig`, so it cannot be defaulted from `ConfigProvider`. */
const FBAlert: React.FC<AlertProps> = props => <Alert showIcon {...props} />;

export default FBAlert;
